/**
 * Returns incremented number each time.
 */

function uniqueNumber() {
    let id = 0;

    const toString = () => {
        id += 1;
        return id;
    };
    return {
        toString,
        valueOf: toString,
    };
}

export default uniqueNumber();
